<div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
    <div class="text-muted small">
        <i class="fas fa-info-circle me-1"></i>
        @if(isEditMode) {
        <b>Activo + obligatorio</b>: precarga slots y obliga a subir esos documentos.
        <b>Activo (no obligatorio)</b>: queda en el snapshot para complementar la solicitud con un select.
        <b>Inactive</b>: no entra al snapshot. Al guardar se preguntará si aplica solo a nuevas o también a abiertas.
        } @else {
        Requisitos del proceso: los <b>obligatorios activos</b> se precargan; los <b>activos opcionales</b> sirven para complementar. Usa <b>Editar</b> para cambiar estado u obligatorio.
        }
    </div>
    <div class="d-flex flex-wrap gap-2 align-items-center">
        @if (!isEditMode) {
            @if (!appSettings.isMobile()) {
            <button class="btn btn-primary btn-sm px-3" (click)="manageRequirements.emit()">
                <i class="fas fa-tasks me-2"></i>Gestionar
            </button>
            <button class="btn btn-outline-primary btn-sm px-3" (click)="toggleEditMode()">
                <i class="fas fa-edit me-2 text-primary"></i> Editar
            </button>
            }
            <button class="btn btn-outline-success btn-sm px-3"
                (click)="syncRequirements.emit()"
                title="Sincronizar requisitos con socios activos">
                <i class="fas fa-sync-alt me-2"></i>Sincronizar
            </button>
        } @else if (!appSettings.isMobile()) {
            <button class="btn btn-primary btn-sm px-3" (click)="saveAll()">
                <i class="fas fa-save me-2"></i> Guardar
            </button>
            <button class="btn btn-outline-secondary btn-sm px-3" (click)="cancelEdit()">
                <i class="fas fa-times me-2 text-danger"></i> Cancelar
            </button>
        }
    </div>
</div>

<app-mobile-footer [visible]="true">
    @if (!isEditMode) {
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="toggleEditMode()">
            <i class="fas fa-edit me-1"></i>Editar
        </button>
        <button type="button" class="btn btn-primary btn-sm flex-grow-1" (click)="manageRequirements.emit()">
            <i class="fas fa-tasks me-1"></i>Gestionar
        </button>
    } @else {
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="cancelEdit()">
            <i class="fas fa-times me-1"></i>Cancelar
        </button>
        <button type="button" class="btn btn-primary btn-sm flex-grow-1" (click)="saveAll()">
            <i class="fas fa-save me-1"></i>Guardar
        </button>
    }
</app-mobile-footer>

@if (appSettings.isMobile()) {
<div class="mobile-cards-scroll">
    @for (group of groupedRequirements; track group.id) {
        <div class="small text-muted fw-bold text-uppercase mb-2 mt-2 px-1">
            {{ group.name }} ({{ group.items.length }})
        </div>
        @for (req of group.items; track req.id ?? req.typeSlug) {
            <app-list-card>
                <div cardTitle class="fw-bold text-dark text-truncate">{{ req.type?.name || catalogService.getDocumentTypeName(req.typeSlug) }}</div>
                <div cardBadge>
                    <span class="badge" [ngClass]="req.ownerSlug === 'PARTY' ? 'bg-indigo' : 'bg-teal'">
                        {{ catalogService.getOwnerName(req.ownerSlug) || 'Otro' }}
                    </span>
                </div>
                <div class="row g-2 text-muted small">
                    <div class="col-12">
                        <span class="text-muted">Días</span>
                        @if (isEditMode) {
                            <input type="number" class="form-control form-control-sm" [(ngModel)]="req.maxDaysAfterProcess">
                        } @else {
                            <div class="fw-semibold text-dark">{{ req.maxDaysAfterProcess || 0 }}</div>
                        }
                    </div>
                </div>
                <div cardExtra class="w-100">
                    <div class="d-flex justify-content-between align-items-center gap-2 mb-2">
                        <span class="text-uppercase fw-semibold">Obligatorio</span>
                        <div class="form-check form-switch mb-0">
                            <input class="form-check-input" type="checkbox" [(ngModel)]="req.isRequired"
                                [disabled]="!isEditMode" (ngModelChange)="onRequiredChange(req)"
                                title="Obligatorio">
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center gap-2">
                        <span class="text-uppercase fw-semibold">Estado</span>
                        <div class="form-check form-switch mb-0">
                            <input class="form-check-input" type="checkbox"
                                [checked]="req.type?.isActive !== false"
                                [disabled]="!isEditMode"
                                (change)="toggleActive(req)"
                                title="Estado">
                        </div>
                    </div>
                </div>
            </app-list-card>
        }
    } @empty {
        <div class="card border-0 shadow-sm p-4 text-center my-2">
            <i class="fas fa-file-signature fa-3x text-muted opacity-50 mb-2"></i>
            <h6 class="text-muted mb-1">Sin requisitos configurados</h6>
        </div>
    }
</div>
} @else {
<div class="table-responsive">
    <table class="table table-hover align-middle mb-0">
        <thead>
            <tr>
                <th style="width: 150px;" class="text-uppercase small fw-bold ">Dueño</th>
                <th class="text-uppercase small fw-bold ">Tipo de Documento / Categoría</th>
                <th class="text-center text-uppercase small fw-bold ">Obligatorio</th>
                <th style="width: 100px;" class="text-center text-uppercase small fw-bold ">Días de Gracia</th>
                <th class="text-center text-uppercase small fw-bold ">Estado</th>
            </tr>
        </thead>
        <tbody>
            @for(group of groupedRequirements; track group.id){
            <!-- Cabecera de Categoría -->
            <tr class="category-header-row">
                <td colspan="5">
                    <div class="d-flex align-items-center">
                        <div class="category-icon-wrapper me-3 d-flex align-items-center justify-content-center"
                            style="width: 32px; height: 32px;">
                            <i class="fas fa-folder-open text-primary"></i>
                        </div>
                        <span class="h6 mb-0 fw-bold letter-spacing-1">{{ group.name | uppercase }}</span>
                        <span class="badge border border-primary text-primary ms-3 rounded-pill">
                            {{ group.items.length }} {{ group.items.length === 1 ? 'requisito' : 'requisitos' }}
                        </span>
                    </div>
                </td>
            </tr>

            <!-- Requisitos -->
            @for(req of group.items; track req.id){
            <tr class="requirement-row animate__animated animate__fadeIn">
                <td>
                    <span class="badge" [ngClass]="req.ownerSlug === 'PARTY' ? 'bg-indigo' : 'bg-teal'">
                        <i class="fas" [ngClass]="req.ownerSlug === 'PARTY' ? 'fa-user' : 'fa-car'"></i>
                        {{ catalogService.getOwnerName(req.ownerSlug) || 'Otro' }}
                    </span>
                </td>
                <td>
                    <div class="fw-bold text-dark">{{ req.type?.name || catalogService.getDocumentTypeName(req.typeSlug) }}</div>
                </td>
                <td class="text-center">
                    <div class="form-check form-switch d-flex justify-content-center">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="req.isRequired"
                            [style.cursor]="isEditMode ? 'pointer' : 'default'"
                            [disabled]="!isEditMode" (ngModelChange)="onRequiredChange(req)">
                    </div>
                </td>
                <td class="text-center">
                    @if(isEditMode) {
                    <input type="number" class="form-control form-control-sm text-center"
                        [(ngModel)]="req.maxDaysAfterProcess">
                    } @else {
                    <span class="badge bg-light text-dark fw-normal border">{{ req.maxDaysAfterProcess || 0 }}
                        días</span>
                    }
                </td>
                <td class="text-center">
                    <div class="form-check form-switch d-flex justify-content-center">
                        <input class="form-check-input" type="checkbox"
                            [style.cursor]="isEditMode ? 'pointer' : 'default'"
                            [checked]="req.type?.isActive !== false"
                            [disabled]="!isEditMode"
                            (change)="toggleActive(req)">
                    </div>
                </td>
            </tr>
            }
            } @empty {
            <tr>
                <td colspan="5" class="text-center p-5 text-muted">
                    <div class="mb-3 animate__animated animate__pulse animate__infinite">
                        <i class="fas fa-file-signature fa-3x opacity-20"></i>
                    </div>
                    <h5 class="fw-bold">Sin requisitos configurados</h5>
                </td>
            </tr>
            }
        </tbody>
    </table>
</div>
}

